import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A section of open cable trench: a concrete-lined channel with power cables
// laid in a sand bed, warning tape over them, and a couple of concrete cover
// slabs slid aside ready to close it up. A groundworks prop that ties buildings
// to the grid.
const GROUND = "#6e5a3a";
const WALL = "#9a948a";
const SAND = "#b8a06a";
const SLAB = "#9aa0a6";
const TAPE = "#f2c14e";
const CABLE_A = "#23232a";
const CABLE_B = "#b5463a";

export const cableTrench = defineModel({
  id: "cable-trench",
  batchId: "electric",
  name: "Cable trench",
  tags: ["prop", "electric", "power", "cable", "groundwork"],
  summary: "An open cable trench with laid cables and cover slabs aside.",
  footprint: 0.6,
  parts(): Part[] {
    const parts: Part[] = [
      // Two ground blocks either side of an open channel sunk between them.
      { geometry: new THREE.BoxGeometry(1.3, 0.22, 0.26), color: GROUND, position: [0, 0.11, -0.27] },
      { geometry: new THREE.BoxGeometry(1.3, 0.22, 0.26), color: GROUND, position: [0, 0.11, 0.27] },
      // Concrete-lined trench walls (inner faces) and a low sand bed at the bottom.
      { geometry: new THREE.BoxGeometry(1.3, 0.22, 0.03), color: WALL, position: [0, 0.11, -0.14] },
      { geometry: new THREE.BoxGeometry(1.3, 0.22, 0.03), color: WALL, position: [0, 0.11, 0.14] },
      { geometry: new THREE.BoxGeometry(1.3, 0.05, 0.25), color: SAND, position: [0, 0.025, 0] },
    ];
    // Round cables lying recessed in the channel, below ground level.
    parts.push(
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 1.3, 8), color: CABLE_A, position: [0, 0.09, -0.06], rotation: [0, 0, Math.PI / 2] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 1.3, 8), color: CABLE_A, position: [0, 0.09, 0.06], rotation: [0, 0, Math.PI / 2] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 1.3, 8), color: CABLE_B, position: [0, 0.14, 0.0], rotation: [0, 0, Math.PI / 2] },
      // Yellow warning tape over the cables, still down in the channel.
      { geometry: new THREE.BoxGeometry(1.3, 0.012, 0.06), color: TAPE, position: [0, 0.18, 0] },
    );
    // Two concrete cover slabs lifted out and laid on the ground beside the trench.
    parts.push(
      { geometry: new THREE.BoxGeometry(0.36, 0.05, 0.24), color: SLAB, position: [-0.38, 0.25, 0.44], rotation: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.36, 0.05, 0.24), color: SLAB, position: [0.22, 0.25, 0.46], rotation: [0, -0.15, 0] },
    );
    return parts;
  },
  animations: [],
});
